import { Skeleton } from "@/components/ui/skeleton";
import { TIPO_INTERACAO_LABEL } from "@/features/instituicao-interacao/labels";
import { formatDateBr } from "@/lib/format";
import { useInteracoesRecentes } from "../api";

const MAX_INTERACOES_TV = 6;

/** Últimas interações na Home (tela CS), ao lado do gráfico. */
export function Interacoes() {
  const { data, isLoading } = useInteracoesRecentes();
  return (
    <section className="flex max-h-[26rem] flex-col rounded-xl border border-border bg-card p-5 shadow-card">
      <h2 className="mb-3 text-base font-semibold text-foreground">Últimas interações</h2>
      {isLoading ? (
        <Skeleton className="h-64 w-full" />
      ) : !data?.length ? (
        <p className="text-sm text-muted-foreground">Nenhuma interação registrada.</p>
      ) : (
        <ol className="-mr-2 space-y-3 overflow-y-auto pr-2">
          {data.map((item) => (
            <li key={item.id} className="border-b border-border pb-3 last:border-0">
              <p className="flex flex-wrap items-baseline justify-between gap-x-2 text-sm">
                <span className="font-medium text-foreground">{item.usuarioResponsavel?.nome ?? "—"}</span>
                <span className="text-xs text-muted-foreground">
                  {item.tipoInteracao ? (TIPO_INTERACAO_LABEL[item.tipoInteracao] ?? item.tipoInteracao) : ""}
                  {" · "}
                  {formatDateBr(item.dataInteracao)}
                </span>
              </p>
              {item.instituicao?.nomeFantasia && <p className="text-xs text-muted-foreground">{item.instituicao.nomeFantasia}</p>}
              {item.descricao && <p className="mt-1 whitespace-pre-line text-sm text-foreground">{item.descricao}</p>}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}

/** Coluna discreta do slide CS na TV: só as mais recentes, descrição cortada em duas linhas. */
export function InteracoesTv() {
  const { data, isLoading } = useInteracoesRecentes({ autoAtualizar: true });
  return (
    <>
      <h2 className="mb-4 text-lg font-medium text-slate-400">Últimas interações</h2>
      {isLoading ? (
        <Skeleton className="h-64 w-full bg-white/10" />
      ) : !data?.length ? (
        <p className="text-base text-slate-500">Nenhuma interação registrada.</p>
      ) : (
        // Em tela baixa o último item é cortado: esmaece em vez de cortar seco.
        <ol className="flex min-h-0 flex-col gap-4 overflow-hidden [mask-image:linear-gradient(to_bottom,black_85%,transparent)]">
          {data.slice(0, MAX_INTERACOES_TV).map((item) => (
            <li key={item.id} className="border-b border-white/5 pb-4 last:border-0">
              <p className="flex items-baseline justify-between gap-2 text-base">
                <span className="truncate font-medium text-slate-300">{item.usuarioResponsavel?.nome ?? "—"}</span>
                <span className="shrink-0 text-sm text-slate-500">{formatDateBr(item.dataInteracao)}</span>
              </p>
              <p className="truncate text-sm text-slate-500">
                {[item.tipoInteracao && (TIPO_INTERACAO_LABEL[item.tipoInteracao] ?? item.tipoInteracao), item.instituicao?.nomeFantasia]
                  .filter(Boolean)
                  .join(" · ")}
              </p>
              {item.descricao && <p className="mt-1 line-clamp-2 text-sm text-slate-400">{item.descricao}</p>}
            </li>
          ))}
        </ol>
      )}
    </>
  );
}
